import React from 'react';

export const ProductImage = ({ image }) =>
  <figure>
    <img src={image} alt="Product" />
  </figure>
    